// extracted by mini-css-extract-plugin
export var button = "background-title-button-section-module--button--Iy-ED";
export var content = "background-title-button-section-module--content--prp7+";
export var desktops = "background-title-button-section-module--desktops--J0aWR";
export var image = "background-title-button-section-module--image--uxLn+";
export var innerWrapper = "background-title-button-section-module--inner-wrapper--gZCXl";
export var left = "background-title-button-section-module--left--4Ny7D";
export var lowerTablets = "background-title-button-section-module--lower-tablets--L6I5P";
export var outerWrapper = "background-title-button-section-module--outer-wrapper--YDOMM";
export var right = "background-title-button-section-module--right--+weyT";
export var text = "background-title-button-section-module--text--1HP2I";